export const UNORDERED_LIST_TAG_NAME = 'ul';
